namespace $.$$ {

	$mol_style_define( $shm_hitalama_resizer_side, {

		opacity: 0.1,
		position: 'absolute',
		top: 0,
		bottom: 0,
		width: '12px',
		cursor: 'ew-resize',
		zIndex: $mol_layer.float,
		touchAction: 'none',

		':hover': {
			background: {
				color: $mol_theme.shade,
			},
		},
		'[rise_dragged]': {
			true: {
				background: {
					color: $mol_theme.line,
				},
			},
		},

	} )

}
